var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.838,
    height: 24.838,
    viewBox: "0 0 24.838 24.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_morado",
    "data-name": "close morado",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72711",
    "data-name": "Trazado 72711",
    d: "M2.351,0H28.776a2.2,2.2,0,0,1,2.351,2,2.2,2.2,0,0,1-2.351,2H2.351A2.2,2.2,0,0,1,0,2,2.2,2.2,0,0,1,2.351,0Z",
    transform: "translate(2.828 0) rotate(45)",
    fill: "#9b2690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72712",
    "data-name": "Trazado 72712",
    d: "M2.351,0H28.776a2.2,2.2,0,0,1,2.351,2,2.2,2.2,0,0,1-2.351,2H2.351A2.2,2.2,0,0,1,0,2,2.2,2.2,0,0,1,2.351,0Z",
    transform: "translate(0 22.01) rotate(-45)",
    fill: "#9b2690"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSvg);
export default __webpack_public_path__ + "static/media/CloseSvg.66603ad508bf50b83c80da3290219deb.svg";
export { ForwardRef as ReactComponent };